export default __webpack_public_path__ + "static/wtu_2-mobile-7052dbc5987ba4952d9b4f05b95779ba.jpg";